import { render, staticRenderFns } from "./PermisosForm.vue?vue&type=template&id=685aac46"
import script from "./PermisosForm.vue?vue&type=script&lang=ts"
export * from "./PermisosForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports